import {
  Avatar,
  Card,
  CardActionArea,
  CardContent,
  Drawer,
  Stack,
  Typography,
} from '@mui/material'
import { IconButton } from 'utoniq-ui'

import { EventBoxFragment } from '@/clients/utoniq-core/schema'
import { EventCategory } from '@/components/organisms'
import { styleSets } from '@/components/styles'
import { useRouter, useTranslation } from '@/core'
import { Cell, CellFrame, Organism, OrganismFrame } from '@/core/architecture'

type EventModalProps = {
  open: boolean
  onClose: () => void
  event: EventBoxFragment
}

export const EventModal: Organism<EventModalProps> = ({
  open,
  onClose,
  event,
}) => {
  const { t } = useTranslation('consoleCollectionDetail')

  if (!event) return null

  return (
    <OrganismFrame>
      <Drawer open={open} onClose={onClose}>
        <Stack sx={{ p: 5 }} direction="row" alignItems="center">
          <Typography
            variant="h6"
            align="center"
            sx={{ width: '100%', ml: '30px' }}
          >
            {t('eventList')}
          </Typography>
          <IconButton.Close edge="end" size="small" onClick={onClose} />
        </Stack>
        <Stack sx={{ px: 5, pb: 5 }} spacing={2}>
          <EventItem event={event} key={event.id} />
        </Stack>
      </Drawer>
    </OrganismFrame>
  )
}

type EventItemProps = {
  event: EventBoxFragment
}
const EventItem: Cell<EventItemProps> = ({ event }) => {
  const { t } = useTranslation('consoleCollectionDetail')
  const { generatePath, routerPages } = useRouter()
  return (
    <CellFrame>
      <Card elevation={0} sx={{ borderRadius: 2 }}>
        <CardActionArea
          href={generatePath(routerPages.ConsoleShokufesEventDetail, {
            eventId: event.id,
          })}
        >
          <CardContent sx={{ py: 2, px: 3, '&:last-child': { pb: 2 } }}>
            <Stack direction="row" spacing={2}>
              <Avatar
                variant="square"
                src={event.thumbnail?.uri ?? ''}
                sx={{ width: 100, height: 66 }}
              />
              <Stack flex={1} spacing={1} sx={{ minWidth: 0 }}>
                <Stack direction="row" spacing={2} alignItems="center">
                  <EventCategory event={event} />
                  <Typography variant="caption" color="text.secondary">
                    {t('date', { date: event.dateRange })}
                  </Typography>
                </Stack>
                <Typography variant="subtitle1" sx={styleSets.lineCamp(1)}>
                  {event.title}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {t('collection', {
                    number: event.eventCollections?.edges?.length ?? 0,
                  })}
                </Typography>
              </Stack>
            </Stack>
          </CardContent>
        </CardActionArea>
      </Card>
    </CellFrame>
  )
}
